import type { AccountPreferences } from "../../api/accountSettings";

export const ACCOUNT_LANGUAGE_EVENT = "arabian:account-language";
export const DEFAULT_ACCOUNT_PREFERENCES: AccountPreferences = {
  push_enabled: true,
  language: "en",
  text_size: "standard",
  density: "comfortable",
  date_format: "dd/MM/yyyy",
  timezone: "Africa/Cairo",
};
let savedLanguage: "en" | "ar" | null = null;
export function getAccountLanguage() {
  return savedLanguage;
}
export function publishAccountLanguage(language: "en" | "ar" | null) {
  savedLanguage = language;
  window.dispatchEvent(
    new CustomEvent(ACCOUNT_LANGUAGE_EVENT, { detail: language }),
  );
}
export function formatAccountDate(
  date: Date,
  preferences: AccountPreferences,
): string {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: preferences.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const value = (type: string) =>
    parts.find((part) => part.type === type)?.value ?? "";
  const y = value("year"),
    m = value("month"),
    d = value("day");
  return preferences.date_format === "yyyy-MM-dd"
    ? `${y}-${m}-${d}`
    : preferences.date_format === "MM/dd/yyyy"
      ? `${m}/${d}/${y}`
      : `${d}/${m}/${y}`;
}
